import { RequestService } from '@tcc-online/request-service';

const AuthService = {
    requestResetPassword,
    resetPassword,
};

async function requestResetPassword(payload: { email: string }) {
    const { email } = payload;
    return await RequestService.post(
        '/request-reset-password',
        {
            email,
        },
        { ignoreAuth: true },
    );
}

async function resetPassword(payload: {
    controlPassword: string;
    password: string;
}) {
    const { controlPassword, password } = payload;

    return await RequestService.post(
        '/reset-password',
        {
            controlPassword,
            password,
        },
        { ignoreAuth: true },
    );
}

export default AuthService;
